import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionAccountPaymentInstructionSplitReasonEnum } from './enum/monthly-pension-account-payment-instruction-split-reason.enum';
import { MonthlyPensionAccountPaymentInstructionDesignationEnum } from './enum/monthly-pension-account-payment-instruction-designation.enum';

export class MonthlyPensionAccountSplitReasonAvailability implements Deserializable {
  public splitReasonId!: MonthlyPensionAccountPaymentInstructionSplitReasonEnum;
  public available!: boolean;
  public unavailableReason!: string | null;
  public targetsThisInstruction!: boolean;
  public recipientDesignations!: MonthlyPensionAccountPaymentInstructionDesignationEnum[];

  public onDeserialize(): void {}
}
